export default __webpack_public_path__ + "static/logo-339e0f9fe8911d884bb5147f7e2fd5a1.png";